import React from "react";
import { Link } from "react-router-dom";
import * as Api from "../api/authentication";
import { toast } from "react-toastify";
import TextInput from "./common/TextInput";

class RegistrationPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userName: "",
            password: "",
            firstName: "",
            lastName: "",
            email: "",
            error: null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    //state = {
    //    userName: "",
    //    password: "",
    //    firstName: "",
    //    lastName: "",
    //    email: ""
    //};

    //async componentDidMount() {
    //    // This binding is necessary to make `this` work in the callback
    //    debugger;
    //    this.handleChange = this.handleChange.bind(this);
    //    this.handleLostFocus = this.handleLostFocus.bind(this);
    //    this.handleSave = this.handleSave.bind(this);
    //}

    handleChange(event) {
        let value = event.target.value;
        this.setState({ [event.target.id]: value });
        this.setState({ error: false });
    }

    async handleSave(event) {
        event.preventDefault();
        try {
            let regResp = await Api.register(this.state);
            if (regResp.succeeded) {
                toast.success("Usuario registrado exitosamente");

                this.props.onRegistration({
                    id: regResp.newId,
                    userName: this.state.userName,
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    email: this.state.email,
                    hasProfile: false,
                    permissions: regResp.data.permissions
                });
            } else this.setState({ error: regResp.message });
        } catch (error) {
            toast.error("Hubo un error al registrar");
        }
    }

    render() {
        return (
            <>
                <div className="form-group">
                    <label>Registro</label>

                    <form onSubmit={this.handleSave}>
                        <TextInput
                            id="userName"
                            label="Usuario"
                            value={this.state.userName}
                            onChange={this.handleChange}
                        />

                        <TextInput
                            id="firstName"
                            label="Nombre"
                            value={this.state.firstName}
                            onChange={this.handleChange}
                        />
                        <TextInput
                            id="lastName"
                            label="Apellidos"
                            value={this.state.lastName}
                            onChange={this.handleChange}
                        />
                        <div className="form-group row">
                            <label htmlFor="password" className="col-sm-2 col-lg-2 col-form-label">
                                Contraseña
                            </label>
                            <div className="col-sm-10 col-lg-6 field">
                                <input
                                    id="password"
                                    type="password"
                                    className="form-control"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                        <TextInput
                            id="email"
                            label="Email"
                            value={this.state.email}
                            onChange={this.handleChange}
                        />
                        {this.state.error && (
                            <div className="alert alert-danger">{this.state.error}</div>
                        )}
                        <input type="submit" value="Registrar" className="btn btn-primary" />
                    </form>

                    <div>
                        <label>Ya tienes cuenta?</label>
                        <Link to={"/Login"} className="btn btn-primary btn-sm">
                            Inicia sesión
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}
export default RegistrationPage;
